import type { QueryClient } from '@tanstack/react-query';

export function setProperty<T>(
  queryClient: QueryClient,
  queryKey: any[],
  propsToUpdate: Partial<T>
) {
  queryClient.setQueryData(queryKey, (oldData: T | undefined) => {
    if (!oldData) {
      // eslint-disable-next-line no-console
      // console.warn(`No existing data found for key: ${queryKey}`);
      return oldData;
    }
    return {
      ...oldData,
      ...propsToUpdate,
    };
  });
}
